import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import BlogPreview from '../components/BlogPreview';
import { ArticleMainSec, ArticleSideSec, MainSec } from '../components/MainSecDivision';
import { CategorySection } from '../components/Category';
import Seo from "../components/seo.js";
import { rhythm } from "../utils/typography";
import Bio from '../components/Bio';
import EmojiWrapper from "../components/EmojiWrapper";

const HomeIndex = ({ data, location }) => {
  const posts = data.allMdx.edges

  return (
    <Layout location={location}>
      <Seo
        title="Recent Posts "
        pathname={location.pathname}
      />
      <Bio /> 
      <MainSec >
        <ArticleMainSec>
          <h4 style={{
            color: 'var(--color-primary)',
            margin: `0 0 ${rhythm(1)} ${rhythm(1)}`
          }}>
            <EmojiWrapper emoji="📰" name="recently published" /> Recently published
          </h4>
          <BlogPreview posts={posts} />
        </ArticleMainSec>
        <ArticleSideSec>
          <div style={{
            marginBottom: rhythm(0.5),
            position: 'sticky',
            top: '20px'
          }}>
            <CategorySection />
          </div>
        </ArticleSideSec>
      </MainSec>

    </Layout >
  )
}

export default HomeIndex;

export const pageQuery = graphql`
  query  {
    allMdx(
      sort: { fields: [frontmatter___date ], order: DESC }
      limit: 8
    ) {
      edges {
        node { 
          timeToRead
          excerpt(pruneLength: 120)
          fields {
            slug
          }
          frontmatter {
            title
            caption
            category
            description
            tags
            date(formatString: "MMMM Do, YYYY")
            featuredImage{
              childImageSharp {
                fixed(width: 220, height: 220) {
                ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
  `

  // date(formatString: "MMMM DD, YYYY")